exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".date-selector-font[data-v-a24a10de]{font-size:20px}.custom-text-align[data-v-a24a10de]{text-align:right!important}@media (max-width:767px){.date-selector-font[data-v-a24a10de]{font-size:11px}.custom-text-align[data-v-a24a10de]{text-align:left!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a24a10de","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewmaker/viewmaker-date-selector.vue
// module id = 1527
// module chunks = 0